import {SatelliteNValues} from '../../types/ndi.types';
import {IGridStatus}      from '../../ap-interface/interfaces/ap-grid-status.interface';
import IGuid = System.IGuid;
import IFieldCrop = Data.FieldManagement.IFieldCrop;

export enum NdiGridItemState {
  GreenAutumn = 1,
  GreenRegular = 2,
  Yellow = 3
}

export enum NdiNUptakeState {
  Green = 1,
  Yellow = 2,
  Grey = 3
}

export interface INdiGridData {
  Id: IGuid;
  Status: IGridStatus;
  Name: string;
  Nr: number;
  TNr: number;
  NrSNr: string;
  FieldCrop: IFieldCrop;
  CropType: string;
  EcValue: number | null;
  Area: number;
  Date: Date;
  NUptakeStatus: IGridStatus;
  SatelliteNValues: SatelliteNValues | undefined;
}

export enum NdiActiveView {
  NIndex = 0,
  NUptake = 1
}

export enum SatelliteMassEditAction {
  Edit = 0
}
